<script setup lang="ts">
import { useResolveLabel, useContext, useDialogs, useLocalization } from '@hantera/portal-app'
import { computed } from 'vue'
import CreateChannelDialog from './CreateChannelDialog.vue'

const t = useLocalization('settings.channels')
const context = useContext()
const dialogs = useDialogs()
const { resolve: resolveLabel } = useResolveLabel()

const canWrite = computed(() => context.authorize('registry/channels:write'))

const props = defineProps<{
  channels: Array<{ key: string; data: Record<string, any> }>
  selectedKey: string | null
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'select', key: string | null): void
  (e: 'created', key: string): void
}>()


function openCreateDialog() {
  const existingKeys = props.channels.map(c => c.key)
  dialogs.openModal(
    t('create.title'),
    CreateChannelDialog,
    true,
    { existingKeys, onCreated: (key: string) => emit('created', key) }
  )
}
</script>

<template>
  <div class="sidebar-section" style="height: 100%">
    <div class="sidebar-header">
      <button
        v-if="canWrite"
        class="btn-primary"
        @click="openCreateDialog"
      >{{ t('createNew') }}</button>
    </div>

    <div v-if="loading" class="sidebar-loading">Loading...</div>

    <div v-else class="neat-scroll" style="flex: 1; overflow-y: auto">
      <div
        v-for="ch in channels"
        :key="ch.key"
        :class="['sidebar-item', { 'sidebar-item--selected': ch.key === selectedKey }]"
        @click="emit('select', ch.key)"
      >
        <div class="sidebar-item-content">
          <div class="sidebar-item-label">{{ ch.key }}</div>
          <div class="sidebar-item-sub-label" v-if="resolveLabel(ch.data?.label)">{{ resolveLabel(ch.data?.label) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
